module.exports = __webpack_public_path__ + "img/silder_01_slogan_02.e9f5a3b4.png";